module.exports = __webpack_public_path__ + "img/ranged.b299a2d9.svg";